<template>
  <v-col cols="12" class="py-0">
    <v-row>
      <v-col cols="12" sm="6" md="9" class="py-0">
        <v-pagination
          v-model="currentPage"
          :length="page.last"
          :total-visible="10"
          v-if="page.last > 1"
          class="smaller"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3" class="py-0 hidden-sm-and-down">
        <p align="right" style="margin: 0" class="smaller">
          {{ $t("tables.rows-per-page") }}
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on }">
              <v-btn class="my-2" v-on="on" height="32">{{ limit }}</v-btn>
            </template>
            <v-list dense>
              <v-list-item
                v-for="(item, i) in limits"
                :key="i"
                :to="limitLink(i)"
                :class="{
                  'v-list-item--active': item === limit
                }"
                exact
              >
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </p>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: "Paginator",
  props: {
    pageObject: {
      type: Object
    },
    pageGetter: {
      type: String
    },
    pageLimitGetter: {
      type: String
    },
    limits: {
      type: Object,
      default: () => ({
        25: 25,
        50: 50,
        100: 100,
        200: 200
      })
    }
  },
  computed: {
    page: {
      get() {
        let page;
        if (this.pageObject && Object.keys(this.pageObject).length) {
          page = this.pageObject;
        } else {
          page = this.$store.getters[this.pageGetter];
        }
        return page || {};
      }
    },
    limit() {
      return this.page.limit;
    },
    currentPage: {
      get() {
        return +this.$route.query.page || 1;
      },
      set(page) {
        if (+this.currentPage === +page) return;
        let to = { ...this.$route };
        to.query = {
          ...to.query,
          page
        };
        this.$router.push(to);
      }
    }
  },
  methods: {
    limitLink(limit_items) {
      let to = { ...this.$route };
      to.query = {
        ...to.query,
        limit_items
      };
      if (
        this.pageGetter !==
          "projectMeteringStore/meterUnitRecordStore/getPage" &&
        this.pageGetter !== "projectMeteringStore/transmissionStore/getPage"
      ) {
        to.query.page = 1;
      }
      return to;
    }
  },
  mounted() {
    this.$router.push(this.limitLink(this.limit));
  }
};
</script>

<style lang="scss" scoped>
.smaller {
  transform: scale(0.8, 0.8);
  &::v-deep {
    .v-pagination__item,
    .v-pagination__navigation {
      border-radius: 0;
    }
  }
}
</style>
